// extracted by mini-css-extract-plugin
export default {"logo":"OpE4qk9BId44_A85o9wO","logoMobile":"z3phHrvM3F5prHIgNvhJ","imageContainerWeb":"VMopWmSG3wRW6jcX_Ck1","imageContainerMobile":"euYOMYNeOcf1K7A9vjja"};